import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Banner.css';

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Local images from public/images folder
  const slides = [
    {
      id: 1,
      image: '/images/banner-1.jpg',
      title: 'All your child\'s school books, in one click!',
      subtitle: '',
      description: 'Browse and purchase curated school book kits for students from Standard 1 to 10',
      overlay: 'rgba(37, 99, 235, 0.75)'
    },
    {
      id: 2,
      image: '/images/banner-2.jpg',
      title: 'Complete Book Sets',
      subtitle: 'School Approved',
      description: 'Every kit contains all required books approved by your specific school',
      overlay: 'rgba(139, 92, 246, 0.75)'
    },
    {
      id: 3,
      image: '/images/banner-3.jpg',
      title: 'Easy Delivery Options',
      subtitle: 'School Pickup or Home Delivery',
      description: 'Choose the delivery method that works best for you',
      overlay: 'rgba(236, 72, 153, 0.75)'
    },
    {
      id: 4,
      image: '/images/banner-4.jpg',
      title: 'Secure & Reliable',
      subtitle: 'Trusted by Thousands',
      description: 'Secure payment processing with multiple payment options',
      overlay: 'rgba(14, 165, 233, 0.75)'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="banner-container">
      <div className="banner-slider">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`banner-slide ${index === currentSlide ? 'active' : ''}`}
            style={{
              backgroundImage: `url(${slide.image})`,
              '--overlay-color': slide.overlay
            }}
          >
            <div className="banner-overlay"></div>
            <div className="banner-content">
              <div className="banner-text">
                <h1 className="banner-title animate-fade-in">
                  {slide.title}
                </h1>
                {slide.subtitle && (
                  <h2 className="banner-subtitle animate-fade-in-delay">
                    {slide.subtitle}
                  </h2>
                )}
                <p className="banner-description animate-fade-in-delay-2">
                  {slide.description}
                </p>
                <div className="banner-buttons animate-fade-in-delay-3">
                  <Link to="/register" className="btn-banner btn-banner-primary">
                    Get Started
                  </Link>
                  <Link to="/schools" className="btn-banner btn-banner-secondary">
                    Browse Schools
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Navigation Arrows */}
        <button className="banner-nav banner-nav-prev" onClick={prevSlide} aria-label="Previous slide">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
        <button className="banner-nav banner-nav-next" onClick={nextSlide} aria-label="Next slide">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>

        {/* Slide Indicators */}
        <div className="banner-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`banner-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            ></button>
          ))}
        </div>

        {/* Floating Elements for Wow Effect */}
        <div className="banner-floating-elements">
          <div className="floating-element floating-1">📚</div>
          <div className="floating-element floating-2">✏️</div>
          <div className="floating-element floating-3">📖</div>
          <div className="floating-element floating-4">🎓</div>
        </div>
      </div>
    </div>
  );
};

export default Banner;

